import SurveyFormat from './surveyFormatEnum';
import { GetCurrentSurveySessionQuery } from '~lib/generatedGqlTypes';

type Survey = NonNullable<GetCurrentSurveySessionQuery['surveyTakingSession']['respondent']['survey']>;
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const extrapolateSurveyData = (survey: Survey) => {
  return {
    isOQAAT: survey.format === SurveyFormat.OQAAT,
    isClassicMode: survey.format === SurveyFormat.CLASSIC,
    isFooterEnabled: survey.design?.footer?.enabled,
    isProgressBarEnabled: survey.design?.progressBar?.enabled,
    isQuestionNumberingEnabled: survey.design?.questionNumbering?.enabled,
    isExitLinkEnabled: survey.navigation?.exit !== null,
    isSurveyTitleEnabled: survey.design?.surveyTitle.enabled,
    logo: {
      enabled: survey.design?.logo?.enabled,
      size: survey.design?.logo?.size,
      height: survey.design?.logo?.height,
      width: survey.design?.logo?.width,
      verticalAlignment: survey.design?.logo?.verticalAlignment,
      imageUrl: survey.design?.logo?.image?.url,
      description: survey.design?.logo?.image?.description,
    },
    totalPages: survey.pages?.totalCount,
    showPageTitles: survey.design?.showPageTitles,
    showPageNumbers: !!survey.design?.showPageNumbers,
    showRequiredQuestionAsterisks: survey.design?.showRequiredQuestionAsterisks,
    surveyTitle: survey.title,
    surveyTitleAlignment: survey.design?.surveyTitle.horizontalAlignment,
    surveyTitleHTML: survey.titleHTML,
    themeVersion: survey.design?.theme?.version,
    totalQuestionsCount: survey.questionCount,
    labels: {
      ok: survey.navigation?.ok.label,
      previous: survey.navigation?.previous.label,
      next: survey.navigation?.next.label,
      done: survey.navigation?.done.label,
      exit: survey.navigation?.exit?.label,
    },
    progressBar: {
      position: survey.design?.progressBar?.position,
      showPercent: survey.design?.progressBar?.showPercent,
      showPageCount: survey.design?.progressBar?.showPageNumber,
    },
  };
};

export default extrapolateSurveyData;
